module.exports = __webpack_public_path__ + "img/bg-video-3.5ff0d260.png";